import {isEmpty, isNil} from 'ramda';

import type {PhotoCheckerPhotoEvaluationSaleVehiclePhoto} from '@dms/api/vehicle';

import {getPhotoCheckerColorVariant, type PhotoCheckerVariant} from './getPhotoCheckerColorVariant';

export function getPhotoCheckerBadgeVariant(
  evals: PhotoCheckerPhotoEvaluationSaleVehiclePhoto[] | null | undefined,
  photoTypes: PhotoCheckerPhotoEvaluationSaleVehiclePhoto['photo_type'][]
): PhotoCheckerVariant {
  if (isNil(evals)) {
    return 'missing';
  }

  const matchedEvals = evals.filter((item) => photoTypes.includes(item.photo_type));

  if (isEmpty(matchedEvals)) {
    return 'missing';
  }

  const averageScore = Math.trunc(
    matchedEvals.reduce((acc, item) => acc + item.score, 0) / matchedEvals.length
  );

  return getPhotoCheckerColorVariant(averageScore);
}
